import React from 'react';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import FilterWrapper from '../../FilterWrapper';
import { clearSearchFilters, setMoreFiltersOpen } from '../../../../actions';
import { t } from '../../../../helpers/t';

const ClearFilters = () => {
  const dispatch = useDispatch();

  return (
    <FilterWrapper>
      <Button
        type="link"
        size="small"
        className="clear-filters"
        onClick={() => {
          dispatch(setMoreFiltersOpen(false));
          dispatch(clearSearchFilters());
        }}
      >
        {t('directives.listings.listingFilters.clearDrawerFilters')}
      </Button>
    </FilterWrapper>
  );
};

export default ClearFilters;
